var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"master"}},[(_vm.loadingInformation)?_c('menudash'):_vm._e(),(_vm.loadingInformation)?_c('router-view',{attrs:{"tabindex":"1"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }